import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrderItem } from '../models/order-item';
import { CartService } from 'ng-shopping-cart';
import { ActivatedRoute } from '@angular/router';
import { Tenant } from '../models/tenant';
import { TenantService } from '../services/data.tenant';
import { LocaleFormat } from 'ng-shopping-cart';
import { ProductService } from '../services/data.product';
import { Product, SizeModel } from '../models/product';

import { Order_Dto, Order_Item_Dto } from '../models/order-dto';
declare var successMessage;
declare var errorMessage;

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html'
})
export class LandingComponent implements OnInit {
    public tenant: Tenant;
    public items: Product[];
    private h: HttpClient;
    public itemCount: number = 0;
    public itemQuantity: number;
    private code: string;

    constructor(private productService: ProductService, private tenantService: TenantService, private route: ActivatedRoute, http: HttpClient, @Inject('BASE_URL') baseUrl: string, private cartService: CartService<OrderItem>) {
        const id = this.route.snapshot.paramMap.get('id');

        this.h = http;
        this.code = id;

        http.get<Tenant>(baseUrl + 'api/Tenant/Tenants/' + id).subscribe(result => {
            this.tenant = result;
            this.tenant.id = result.id;
            this.tenant.tagline = result.tagline;
            this.tenantService.changeTenant(this.tenant);
            this.getProducts();

        }, error => console.error(error));
    }
    getProducts(): void {
        this.productService.getMyProducts(this.code).then((result: Product[]) => {
            this.items = result;
        }).catch((reason: any) => {
            console.log("Caught!!!");
            console.log(reason);
        });
    }

    ngOnInit() {
        this.tenantService.currentTenant.subscribe(tenant => this.tenant = tenant);
        let reset: boolean = false;
        let quan: number = 0;
        this.cartService.getItems().forEach(function (item) {
            if (item._id === undefined) {
                reset = true;
            }
            else {
                quan += item.getQuantity();
            }
        });
        if (reset) {
            this.cartService.clear();
        }
        this.itemCount = this.cartService.getItems().length;
        this.itemQuantity = quan;
    }

    addToCartClick(event) {
        var arrS = this.items;
        for (var i = 0; i < arrS.length; ++i) {
            const quant = Object.getOwnPropertyDescriptor(arrS[i], "quantity");
            const sizeProp = Object.getOwnPropertyDescriptor(arrS[i], "size");
            var size = sizeProp.value;
            var q = +quant.value;

            console.log(q);
            if (q > 0) {
                var item = arrS[i];
                var anItem: OrderItem = new OrderItem(arrS[i]);
                anItem.setId(item.id + "-" + size);
                var message = "Added " + q + " " + size + " " + anItem.getName();
                this.itemQuantity += q;
                for (var iz = 0; iz < item.sizeMatrix.length; ++iz) {
                    if (item.sizeMatrix[iz].code == size) {
                        anItem._price = item.sizeMatrix[iz].unitPrice;
                        break;
                    }
                }
                var secondItem: OrderItem = this.cartService.getItem(anItem.getId());
                if (secondItem != null) {
                    q = +secondItem.getQuantity() + q;
                }
                anItem.setQuantity(q);
                this.cartService.addItem(anItem);
                quant.value = 0;
                successMessage(message, "Added Product");
            }
        }

        this.itemCount = this.cartService.getItems().length;
    }

    removeFromCartClick(event, item) {
        var anItem: OrderItem = new OrderItem(item);
        anItem.setId(item.id + "-" + item.size);

        var secondItem: OrderItem = this.cartService.getItem(anItem.getId());
        if (secondItem != null) {
            this.cartService.removeItem(anItem.getId());
        }
        item.quantity = 1;
        item.inCart = false;
    }
}

export class TempItem {
    public id: any;
    public name: string;
    public price: number;
    public imageUrl: string;
    public description: string;
    public inCart: boolean;
    public sizeMatrix: SizeModel[];

    public _name: string;
    _price: number;
    _imageUrl: string;
    _quantity: number;
    public size: string;
    public quantity: number;

    public getId(): any {
        return this.id;
    }
    public getName(): string {
        return this.name;
    }
    public getPrice(): number {
        return this.price;
    }
    public getImage(): string {
        return this.imageUrl;
    }
    public getQuantity(): number {
        return 1;
    }
    public setQuantity(quantity: number) {
        this._quantity = quantity;
    }
    constructor() {
        this._name = "Poseidon Series Sweatshirt Hoodie";
        this._price = 10.50;
        this._imageUrl = 'https://i.imgur.com/wxLbQZf.png';
        this._quantity = 1;
        this.description = "This is an awesome sweatshirt designed by CFYN legend Will Turnbull.";
        this.size = "XL";
        this.inCart = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.ts